import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const token = localStorage.getItem('token');
console.log('Токен из localStorage:', token); // <- проверяем, есть ли токен

if (!token) {
    console.warn('Токен не найден, подписка на приватные каналы не будет работать!');
}

export function createEcho(token) {
    if (!token) {
        console.warn('Токен не найден, Echo не инициализирован');
        return null;
    }

    console.log('Echo token:', token)

    return new Echo({
        broadcaster: 'pusher',
        key: '2e8753c3e871e6d3999e',
        cluster: 'ap2',
        forceTLS: true,
        encrypted: true,
        authEndpoint: 'https://admin.mentorme.kz/V1/api/broadcasting/auth',
        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    });
}
